import { DeliveryMethod } from "../constants";
import getIsDeliveryDomestic from "./getIsDeliveryDomestic";

// Sender name field is visible
// - for door to door deliveries
// - for ee door-to-locker
// - for non domestic deliveries in other apps

const getIsSenderNameFieldVisible = (
  deliveryMethod: DeliveryMethod,
  countryFrom: string,
  countryTo: string,
  defaultLocale: string
): boolean => {
  if (deliveryMethod === DeliveryMethod.DoorToDoor) {
    return true;
  }

  if (deliveryMethod === DeliveryMethod.DoorToPudo && defaultLocale === "ee") {
    return true;
  }

  return !getIsDeliveryDomestic(defaultLocale, countryFrom, countryTo);
};

export default getIsSenderNameFieldVisible;
